<template>
    <div>
        <a :href="`/app/guest/${data.guest.id}/invoices/`">View</a>
    </div>
</template>

<script>

export default {
    components: {

    },
    data() {
        return {
            data: {},
        };
    },
    created() {
        this.data = this.params.data;
    },
    computed: {
        
    },
    methods: {
        openGuest() {
            window.location.href = `/app/guest/${this.data.guest.id}/invoices/`;
        },
    },
};
</script>